import React from "react";
import '../scss/MainStyle.css';
const Header = () => {
    return (
        <section id="hero">
            <div className="hero-text">
                <h1>A classic</h1>
                <h2>Gin joint</h2>
                <h1>New York</h1>
            </div>
        </section>
    );
}

export default Header;